import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

const permissionService = {
  // List all dataroom permissions - removed /api prefix as it's already in base URL
  list: async (params = {}) => {
    try {
      const response = await api.get('/dataroom-permissions', { params });
      return normalizeApiResponse(response, 'permissions');
    } catch (error) {
      throw error;
    }
  },

  // Get single permission
  get: async (permissionId) => {
    try {
      const response = await api.get(`/dataroom-permissions/${permissionId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Create permission (Super Admin only)
  create: async (data) => {
    try {
      const response = await api.post('/admin/dataroom-permissions', data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Update permission (Super Admin only)
  update: async (permissionId, data) => {
    try {
      const response = await api.put(`/admin/dataroom-permissions/${permissionId}`, data);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Delete permission (Super Admin only)
  delete: async (permissionId) => {
    try {
      const response = await api.delete(`/admin/dataroom-permissions/${permissionId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Assign permissions to role
  assignToRole: async (roleId, permissionIds) => {
    try {
      const response = await api.post(`/admin/dataroom-roles/${roleId}/permissions`, {
        permission_ids: permissionIds
      });
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Remove permissions from role
  removeFromRole: async (roleId, permissionIds) => {
    try {
      const response = await api.delete(`/admin/dataroom-roles/${roleId}/permissions`, {
        data: { permission_ids: permissionIds }
      });
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Get permissions for a specific role
  getByRole: async (roleId) => {
    try {
      const response = await api.get(`/admin/dataroom-roles/${roleId}/permissions`);
      return normalizeApiResponse(response, 'permissions');
    } catch (error) {
      throw error;
    }
  },

  // Check user permissions in dataroom
  checkUserPermissions: async (dataroomUuid, userId) => {
    try {
      const response = await api.get(`/datarooms/${dataroomUuid}/users/${userId}/permissions`);
      return normalizeApiResponse(response, 'permissions');
    } catch (error) {
      throw error;
    }
  }
};

export default permissionService;